/**
 * Ephemeral slice controlling the SwissPass login prompt shown when an
 * unauthenticated user attempts to start a ticket purchase.
 */

import { defineEphemeralSlice } from "../runtime/defineEphemeralSlice";

/**
 * State of the offer-purchase login prompt.
 */
export interface OfferPurchaseLoginPromptState {

    /** Whether the login prompt modal is currently visible. */
    "isOpen": boolean;
}

/** Default state: the prompt is hidden. */
export const OFFER_PURCHASE_LOGIN_PROMPT_DEFAULT: OfferPurchaseLoginPromptState = { "isOpen": false };

/**
 * Slice used to show or hide the SwissPass login prompt from anywhere in the app.
 *
 * @remarks The modal itself is rendered at the root level (in {@link App}) so it
 * overlays the whole application and is not tied to the panel chrome row.
 */
export const offerPurchaseLoginPromptSlice = defineEphemeralSlice<OfferPurchaseLoginPromptState>( {
    "key":     "offerPurchaseLoginPrompt",
    "default": () => OFFER_PURCHASE_LOGIN_PROMPT_DEFAULT,
} );
